export default (t) => [
  {
    text: t('Name'),
    value: 'name',
    sortable: true,
    width: 220,
    togglable: true
  },
  {
    text: t('Priority'),
    value: 'priority',
    sortable: true,
    width: 90,
    togglable: true
  },
  {
    text: t('_promotion.Tier Mode'),
    value: 'tier_mode',
    sortable: false,
    width: 140,
    togglable: true
  },
  {
    text: t('_promotion.Active'),
    value: 'is_active',
    sortable: false,
    width: 90,
    togglable: true
  },
  {
    text: t('_promotion.Start Date'),
    value: 'start_date',
    sortable: true,
    width: 140,
    togglable: true
  },
  {
    text: t('_promotion.End Date'),
    value: 'end_date',
    sortable: true,
    width: 140,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 100
  },
];
